import { render, staticRenderFns } from "./LinkBannerComponent.vue?vue&type=template&id=628ea4e6&scoped=true&"
import script from "./LinkBannerComponent.vue?vue&type=script&lang=js&"
export * from "./LinkBannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./LinkBannerComponent.vue?vue&type=style&index=0&id=628ea4e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628ea4e6",
  null
  
)

export default component.exports